import {PrintStoryDoc, PrintStoryEvent} from '../types'
import {toMillis} from '../time'

export const mapCommandLogToEvents = (log: PrintStoryDoc): PrintStoryEvent[] => {
  const ts = toMillis(log.publishedAtMs) || toMillis(log.publishedAt) || toMillis(log.createdAt)
  if (!ts) {
    return []
  }

  const ok = log.mqttPublishOk !== false
  const lane =
    log.jobKind === 'prefetch' || String(log.jobId || '').startsWith('prepare:')
      ? 'prefetch'
      : 'print'

  return [
    {
      ts,
      lane,
      laneKey: String(log.deviceId || log.jobId || log.id),
      kind: ok ? 'job_published' : 'job_publish_failed',
      severity: ok ? 'info' : 'danger',
      deviceId: log.deviceId ? String(log.deviceId) : undefined,
      jobId: log.jobId ? String(log.jobId) : undefined,
      contentId: log.contentId ? String(log.contentId) : undefined,
      codeId: log.codeId ? String(log.codeId) : undefined,
      title: ok ? 'MQTT command published' : 'MQTT command publish failed',
      detail: log.mqttPublishError || log.topic,
      sourceCollection: 'printerCommandLogs',
      raw: log,
    },
  ]
}

export const mapCommandLogsToEvents = (logs: PrintStoryDoc[]): PrintStoryEvent[] =>
  logs.flatMap(mapCommandLogToEvents)
